import {Type} from 'main.core';

export class Favorite
{
	constructor(options = {name: 'Favorite'})
	{
		this.name = options.name;
		this.initEventListener()
	}

	initEventListener()
	{
		const instance = this
		$(document).on('click', '.link--favorite', function(e){
			e.preventDefault()
			let id = $(this).parents('[data-element-id]').data('element-id');
			if ($(this).hasClass('is-selected')) {
				instance.remove(id)
			} else {
				instance.add(id)
			}
		})
	}

	add(id)
	{
		$.ajax({
			url: '/local/ajax/api/favorite/add.php',
			method: 'POST',
			data: {id: id},
			success: function(e) {
				$('[data-element-id="'+id+'"]').find('.link--favorite').addClass('is-selected')
				$('.icon-link--star .icon-link__count').removeClass('d-none').html(e.count)
			}
		})
	}

	remove(id)
	{
		$.ajax({
			url: '/local/ajax/api/favorite/delete.php',
			method: 'POST',
			data: {id: id},
			success: function(e) {
				$('[data-element-id="'+id+'"]').find('.link--favorite').removeClass('is-selected')
				$('.icon-link--star .icon-link__count').html(e.count)
			}
		})
	}

	getList(id)
	{
		$.ajax({
			url: '/local/ajax/api/favorite/get.php',
			method: 'POST',
			data: {id: id},
			success: function(e) {
				e.forEach(function(item){
					$('[data-element-id="'+item.ITEM_ID+'"]').find('.link--favorite').addClass('is-selected')
				})
				$('.icon-link--star .icon-link__count').removeClass('d-none').html(e.length)
				setTimeout(function(){
					if(e.length <= 0){
						$('.icon-link--star .icon-link__count').hide()
					}
				}, 1000)
			},
			error: function(e) {
				//
			}
		}).fail(function() {
		    console.log('test');
		})
	}

	setName(name)
	{
		if (Type.isString(name))
		{
			this.name = name;
		}
	}

	getName()
	{
		return this.name;
	}

}